import React from 'react';
import { Dialog, DialogTitle, DialogContent, Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { StyledDialogActions } from 'containers/ExpertExpertise/Dialogs/styles';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/messages';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';

export interface MissionDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  title: string;
  content: any;
  disabled: boolean;
}

const DialogMission: React.FC<MissionDialogProps> = (props): JSX.Element => {
  const { onClose, open } = props;

  return (
    <Dialog
      onClose={/* istanbul ignore next */ () => onClose()}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        <Grid container direction="row" spacing={3}>
          <Grid item xs={11}>
            {props.title}
          </Grid>
          <Grid item>
            <CloseIconBlack onClick={() => onClose()} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>{props.content}</DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testid="cancel-button"
          title={translate({ ...messages.dialogCancelButton }, props)}
        />
        <PrimaryButton
          onClick={() => props.validateDialog()}
          disableElevation
          data-testid="validate-button"
          title={translate({ ...messages.dialogValidationButton }, props)}
          disabled={props.disabled}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

DialogMission.defaultProps = {
  open: false,
};

export default injectIntl(DialogMission);
